import { render, staticRenderFns } from "./NotificationAllowButton.vue?vue&type=template&id=23fab5b0&lang=pug&"
import script from "./NotificationAllowButton.vue?vue&type=script&lang=js&"
export * from "./NotificationAllowButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports